import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { ExcelExport, ExcelExportColumn, ExcelExportColumnGroup } from "@progress/kendo-react-excel-export";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { process as dataProcess } from "@progress/kendo-data-query";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import enMessages from "../../common/kendo-react-messages/ResponseMessage.json";
import moment from "moment";
import { AiOutlineFileExcel } from "react-icons/ai";
import { IconName, SiMicrosoftexcel } from "react-icons/si";
import {
  ExcelSurveyStartLabel,
  ExcelSurveyEndLabel,
  ExcelSurveyStartDate,
  ExcelSurveyEndDate,
} from "../../common/DateFormat";
loadMessages(enMessages, "en-US");

const TextQuestionsGrid = ({ gridData, QuestionNo, surveyDetails, QuestionText }) => {
  // const [currentLocale, setCurrentLocale] = useState(locales[0]);
  const [dataResult, setDataResult] = useState();

  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
  });

  useEffect(() => {
    setDataResult(dataProcess(gridData, dataState));
  }, [gridData, dataState]);

  const dataStateChange = (event) => {
    setDataResult(dataProcess(gridData, event.dataState));
    setDataState(event.dataState);
  };

  let _export;
  const exportExcel = () => {
    const options = _export.workbookOptions();

    options.sheets[0].frozenRows = '0';
    // options.sheets[0].frozenRows = 2;
    const headerRow = {
      cells: [
        // Opened on

        {
          value: ExcelSurveyStartLabel(surveyDetails.StartDate),
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        { value: ExcelSurveyStartDate(surveyDetails.StartDate), color: "#000", background: "#eee", fontSize: 16 },

        // Respondents
        { value: "Total Respondents", color: "#000", background: "#eee", bold: true, fontSize: 16 },
        { value: surveyDetails.uniqueUsers, color: "#000", background: "#eee", fontSize: 16 },
      ],
    };

    const headerRowNext = {
      cells: [
        // Closes on
        {
          value: ExcelSurveyEndLabel(surveyDetails.ExpiryDate),
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        { value: ExcelSurveyEndDate(surveyDetails.ExpiryDate), color: "#000", background: "#eee", fontSize: 16 },

        // Questions
        { value: "Total Questions", color: "#000", background: "#eee", bold: true, fontSize: 16 },
        { value: surveyDetails.totalQuestions, color: "#000", background: "#eee", fontSize: 16 },
      ],
    };

    const headerRowThird = {
      cells: [
        // Downloaded on
        { value: "Downloaded On", color: "#000", background: "#eee", bold: true, fontSize: 16 },
        { value: moment().format("MM/DD/YYYY h:mm A"), color: "#000", background: "#eee", fontSize: 16 },

        // Responses
        { value: "Total Responses", color: "#000", background: "#eee", bold: true, fontSize: 16 },
        { value: surveyDetails.totalquestionResponses, color: "#000", background: "#eee", fontSize: 16 },
      ],
    };

    const headerRowFourth = {
      cells: [
       // Downloaded on
        { value: " ", background: "#fff" },
        { value: " ", background: "#fff" },

        // Responses
        { value: " ", background: "#fff" },
      ],
    };

    const headerRowFive = {
      cells: [
        // Downloaded on
        {
          value: surveyDetails.SurveyName + " By " + surveyDetails.CompanyName,
          color: "#ffffff",
          background: "#32c5ff",
          bold: true,
          fontSize: 16,
          textAlign: "center",
          colSpan: "3",
        },
      ],
    };

    // const headerRowSix = {
    //   cells: [
    //     // Downloaded on
    //     { value: " " },
    //     { value: " " },

    //     // Responses
    //     { value: " " },
    //     { value: " " },
    //   ],
    // };

    // const footerRow = {
    //   cells: [{ value: `Powered by` }, { value: "OpenEyes Technologies Inc.", URL: "https://theopeneyes.com/" }],
    // };

    const rows = options.sheets[0].rows;

    // rows.unshift(headerRowSix);
    rows.unshift(headerRowFive);
    rows.unshift(headerRowFourth);
    rows.unshift(headerRowThird);
    rows.unshift(headerRowNext);
    rows.unshift(headerRow);

    // rows.push(footerRow);
    _export.save(options);
  };

  const filterData = (e) => {
    let value = e.target.value;
    let filter = {
      logic: "or",
      filters: [
        // { field: "index", operator: "contains", value: value },
        { field: "AnswerText", operator: "contains", value: value },
      ],
    };
    // setDataResult({
    //   data: filterBy(overview, filter),
    // });
    // if (dataState.skip > 0) {
    //   setDataResult(filterBy(overview, filter));
    // if (filterBy(overview, filter).length < dataState.skip) {
    setDataResult(filterBy(gridData, filter));
    // } else {
    //   setDataResult(dataProcess(filterBy(overview, filter), dataState));
    // }
    // } else {
    //   setDataResult(dataProcess(filterBy(overview, filter), dataState));
    // }
  };

  const checkPageable = (dataLength) => {
    if (dataLength < 5) {
      return false;
    } else {
      return {
        buttonCount: 4,
        pageSizes: [5, 10, 20, 50, 100],
        pageSize: 5,
      };
    }
  };

  return (
    <>
      {gridData.length > 0 ? (
        <Row>
          <Col lg={12}>
            <div className="chart-table  custom-respo">
              <LocalizationProvider language="en-US">
                <IntlProvider locale="message">
                  <div>
                    <ExcelExport
                      data={gridData}
                      ref={(exporter) => {
                        _export = exporter;
                      }}
                      fileName={
                        surveyDetails.SurveyName != ""
                          ? surveyDetails.SurveyName.split(" ").join("").replace(/\s+/g, "-") +
                            "-Q-#" +
                            QuestionNo +
                            "-" +
                            moment().format("MM-DD-YYYY-hh-mm")
                          : "Survey-Q-#" + QuestionNo + "-" + moment().format("MM-DD-YYYY-hh-mm")
                      }>
                      <ExcelExportColumnGroup>
                        <ExcelExportColumnGroup
                          title={"Question #" + QuestionNo + " " + QuestionText}
                          headerCellOptions={{
                            textAlign: "left",
                            width: "350px",
                            borderBottom: 1,
                            background: "#eee",
                            color: "#000",
                            bold: true,
                          }}>
                          <ExcelExportColumn
                            field="index"
                            title="#"
                            width={50}
                            headerCellOptions={{
                              background: "#eee",
                              bold: true,
                              color: "#000",
                              textAlign: "center",
                            }}
                            cellOptions={{
                              textAlign: "center",
                            }}
                          />
                          <ExcelExportColumn
                            field="AnswerText"
                            title="Responses"
                            width="350px"
                            headerCellOptions={{
                              background: "#eee",
                              bold: true,
                              color: "#000",
                            }}
                          />
                        </ExcelExportColumnGroup>
                      </ExcelExportColumnGroup>
                    </ExcelExport>
                    <Grid
                      // style={{
                      //   height: "700px",
                      // }}
                      sortable={true}
                      filterable={false}
                      groupable={false}
                      // reorderable={true}
                      pageable={checkPageable(gridData.length)}
                      data={dataResult}
                      {...dataState}
                      onDataStateChange={dataStateChange}
                      // expandField="expanded"
                      // onExpandChange={expandChange}
                      // resizable={true}
                      >
                      <GridToolbar>
                        <Input onChange={filterData} placeholder="Search responses" />
                        <div>
                          <button title="Export Excel" className="save-pdf export-btn" onClick={exportExcel}>
                            <SiMicrosoftexcel />
                          </button>
                        </div>
                      </GridToolbar>
                      <GridColumn
                        field="index"
                        title="#"
                        width="50px"
                        className="text-center"
                        headerClassName="text-center"
                      />
                      <GridColumn field="AnswerText" title="Responses" min-width="200px" />
                    </Grid>
                  </div>
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={12} className="text-center mt-5">
            <p className="text-danger mt-5">No data found for this question</p>
          </Col>
        </Row>
      )}
    </>
  );
};

export default TextQuestionsGrid;
